export default "__VITE_ASSET__975136a9__"